<lvr-heading [showEditButton]="false">
	{{ 'assignment.details.impediment_report' | transloco }}
	<div ngProjectAs="button-content">
		@if (!report()?.isFinal) {
			<div [matTooltip]="endTooltip() | transloco">
				<lvr-button
					variant="primary"
					[label]="'base.button.submit' | transloco"
					[ariaLabel]="'assignment.report.impediment.finalize' | transloco"
					[type]="'button'"
					[disabled]="!report()?.canBeSubmitted || !canFinalizeReport() || isDraft()"
					(clicked)="finalize()"
					icon="ios_share"
				></lvr-button>
			</div>
		} @else {
			<lvr-button
				variant="primary"
				[label]="'base.button.export' | transloco"
				[ariaLabel]="'base.button.export_pdf' | transloco"
				[loadingLabel]="'base.button.generating_pdf' | transloco"
				[loading]="isExporting()"
				[type]="'button'"
				(clicked)="export('sachstandsbericht.pdf')"
				icon="ios_share"
			></lvr-button>
		}
	</div>
</lvr-heading>
<section class="form-container">
	<form class="preview-grid" [formGroup]="form">
		<div>
			@if (!report()?.isFinal && !this.isUsbAssignment()) {
				@if (availableImpediments() && availableImpediments()!.length > 0) {
					<p style="margin: 0 0 16px 0">{{ 'assignment.details.impediments' | transloco }}</p>
					<lvr-impediment-list
						formControlName="impediments"
						[groups]="availableImpediments() ?? []"
					></lvr-impediment-list>
				} @else if (!assignment()?.isAdditionalAssignment) {
					<p>{{ 'assignment.details.no_impediments' | transloco }}</p>
				}
			}
		</div>
		@if (renderContent()) {
			<lvr-html-editor
				[readOnly]="(report()?.isFinal ?? false) || !canEditReport()"
				(docChange)="docUpdated($event)"
				[html]="renderContent()"
			></lvr-html-editor>
		}
	</form>
</section>
<div class="form-container">
	@if (!report()?.isFinal) {
		<div
			[matTooltip]="!canEditReport() ? ('base.button.edit_disabled' | transloco) : ''"
			[matTooltipDisabled]="canEditReport()"
		>
			<lvr-default-actions
				[disableSave]="!updateHtmlContent() || !canEditReport()"
				(save)="save()"
				(cancelSave)="cancel()"
				[showLoading]="isLoadingForSaveImpedimentReport()"
			></lvr-default-actions>
		</div>
	}
</div>
